export default [
  {
    meta: {
      requiresAuth: true,
    },
    path: "/mall/list",
    name: "list",
    component: (resolve) => require(["./list.vue"], resolve),
  },
  {
    meta: {
      requiresAuth: true,
    },
    path: "/mall/feedBack",
    name: "feedBack",
    component: (resolve) => require(["./feedBack/feedBack.vue"], resolve),
  },
  {
    meta: {
      requiresAuth: true,
    },
    path: "/mall/approvals",
    name: "approvals",
    component: (resolve) => require(["./huilianyi/huilianyi.vue"], resolve),
  },
  {
    meta: {
      requiresAuth: true,
    },
    name: "booking",
    path: "/mall/booking",
    component: (resolve) => require(["./booking.vue"], resolve),
  },
  {
    meta: {
      requiresAuth: true,
    },
    name: "extendServices",
    path: "/mall/:service/extendServices",
    component: (resolve) => require(["./extendServices/extendServices.vue"], resolve),
  },
  {
    meta: {
      requiresAuth: true,
    },
    name: "mallOrder",
    path: "/mall/:service/order",
    component: (resolve) => require(["./order/order.vue"], resolve),
  },
  {
    meta: {
      requiresAuth: true,
    },
    name: "flightInternalList",
    path: "/mall/flight/Internal/list",
    component: (resolve) => require(["./flight/list.vue"], resolve),
  },
  {
    meta: {
      requiresAuth: true,
    },
    name: "flightOverseasList",
    path: "/mall/flight/Overseas/list",
    component: (resolve) => require(["./flight/list.vue"], resolve),
  },
];



// WEBPACK FOOTER //
// ./src/views/mall/router.js